// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDq0Pi4LAkypsPLFBrwbGP_S55POy5eafk",
    authDomain: "angular-gcl-dashboard.firebaseapp.com",
    databaseURL: "https://angular-gcl-dashboard.firebaseio.com",
    projectId: "angular-gcl-dashboard",
    storageBucket: "angular-gcl-dashboard.appspot.com",
    messagingSenderId: "882642796291",
    appId: "1:882642796291:web:05c22f069b27216e"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
